module.exports = __webpack_public_path__ + "img/microphone.4b52f3c3.png";